import { createApp } from 'vue'
import App from './App.vue'
import router from './router' 
import InstantSearch from 'vue-instantsearch/vue3/es';

createApp(App).use(router).use(InstantSearch).mount('#app')